import React, { useEffect, useState } from "react";
import { Button, Dropdown, Form, Modal, Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faImage,
  faFile,
  faVideo,
  faTimes,
  faThLarge,
  faUpload,
  faCheck,
  faRedo,
} from "@fortawesome/free-solid-svg-icons";
import ReactPlayer from "react-player";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

import {
  ADMIN_ADD_ASYNCHRONOUS_CONTENT,
  ADMIN_ASYNCHRONOUS_CONTENT_GET,
  ADMIN_DELETE_ASYNCHRONOUS_CONTENT,
  API_BASE_URL,
} from "../../../../config";
import { auth } from "../../../../firebase";
import moment from "moment";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button as ButtonM } from '@material-ui/core';
import { toast } from "react-toastify";
toast.configure();

function Resources(props) {
  // CONSTANTS
  const { currentEvent } = props;
  const image_type = ["image/jpeg", "image/png", "image/svg+xml", "image/gif"];
  const pdf_type = ["application/pdf"];
  const word_type = [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const excel_type = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];
  const powerpoint_type = [
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ];

  // STATES
  const [showAddResourceModal, setShowAddResourceModal] = useState(false);
  const [showResourceDetails, setShowResourceDetails] = useState(false);
  const [fetchingResourceList, setFetchingResourceList] = useState(false);
  const [resourceList, setResourceList] = useState([]);
  const [filter, setFilter] = useState("");
  const [selectedResource, setSelectedResource] = useState(null);
  const [newResourceDetails, setNewResourceDetails] = useState(null);
  const [resourceFile, setResourceFile] = useState(null);
  const [resourceTitle, setResourceTitle] = useState("");
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [status, setStatus] = useState("start");
  const [response, setResponse] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [currentItemToRemove, setCurrentItemToRemove] = useState(null);

  // FUNCTIONS
  const handleOpenResource = (resource) => {
    setShowResourceDetails(true);
    setSelectedResource(resource);
  };

  const handleCloseResource = () => {
    setShowResourceDetails(false);
    setSelectedResource(null);
  };

  const handleFetchResourceList = async (cbFetching, cbList, type) => {
    try {
      cbFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${ADMIN_ASYNCHRONOUS_CONTENT_GET}?user_id=${auth?.currentUser?.uid}&parent_id=${currentEvent?.id}&parent_type=${currentEvent?.type}&type=${type}`
      );

      if (response.status === 200) {
        cbFetching(false);
        cbList(response?.data?.data?.resource_list);
      } else {
        cbFetching(false);
      }
    } catch (error) {
      console.log(`[Error] Fetching resource list: `, error.message);
      cbFetching(false);
    }
  };

  const FileIcon = ({ file_content_type, size = "1x" }) => {
    if (image_type?.indexOf(file_content_type) >= 0) {
      return <FontAwesomeIcon icon={faImage} className="mr-2" size={size} />;
    }

    if (pdf_type?.indexOf(file_content_type) >= 0) {
      return <FontAwesomeIcon icon={faFilePdf} className="mr-2" size={size} />;
    }

    if (word_type?.indexOf(file_content_type) >= 0) {
      return <FontAwesomeIcon icon={faFileWord} className="mr-2" size={size} />;
    }

    if (excel_type?.indexOf(file_content_type) >= 0) {
      return (
        <FontAwesomeIcon icon={faFileExcel} className="mr-2" size={size} />
      );
    }

    if (powerpoint_type?.indexOf(file_content_type) >= 0) {
      return (
        <FontAwesomeIcon icon={faFilePowerpoint} className="mr-2" size={size} />
      );
    }

    return <FontAwesomeIcon icon={faFile} className="mr-2" size={size} />;
  };

  const fileSize = (size) => {
    const size_chart = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
    let count = 0;
    while (size > 1024) {
      size /= 1024;
      count += 1;
    }
    return `${size.toFixed(2)} ${size_chart[count]}`;
  };

  const handleRecordedLectureForm = async (e) => {
    e.preventDefault();

    if (!resourceFile) {
      alert("Please select a file");
    }

    const fileData = new FormData();
    fileData.append("file", resourceFile, `${resourceFile?.name}`);
    fileData.append("user_id", auth.currentUser.uid);
    fileData.append("parent_id", currentEvent?.id);
    fileData.append("parent_type", currentEvent?.type);
    fileData.append("title", resourceTitle);

    if (Object.entries(newResourceDetails)?.length > 0) {
      Object.entries(newResourceDetails).forEach((e) => {
        fileData.append(`${e[0]}`, e[1]);
      });
    }

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
      onUploadProgress: (ProgressEvent) => {
        setProgress(
          Math.round((ProgressEvent.loaded * 100) / ProgressEvent.total)
        );
        if ((ProgressEvent.loaded * 100) / ProgressEvent.total === 100) {
          setStatus("await");
        }
      },
    };

    try {
      setUploading(true);
      let response = await axios.post(
        `${API_BASE_URL}${ADMIN_ADD_ASYNCHRONOUS_CONTENT}`,
        fileData,
        config
      );

      const { status, data, message } = response;

      if (status === 200) {
        console.log("[Success] Uploading Resource: ", data.data);
        setStatus("success");
        setResponse(data.data);
      } else {
        setStatus("failure");
        setErrorMsg(message);
      }
      setUploading(false);
      handleRefresh();
    } catch (error) {
      console.log(`[Error] Uploading Resource: ${error.message}`);
      setUploading(false);
      setStatus("failure");
      setErrorMsg(error.message);
    }
  };

  const handleCloseAsyncContentModal = () => {
    setShowAddResourceModal(false);
    setResourceFile(null);
    setResourceTitle("");
    setUploading(false);
    setProgress(0);
    setStatus("start");
    setResponse(null);
    setErrorMsg("");
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentItemToRemove(null);
  };

  const ConfirmationDialog = ({ open, onClose, onConfirm }) => {
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Delete Media</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {`Are you sure you want to delete "${currentItemToRemove?.fileName}" ?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonM onClick={onClose} color="primary">
            No
          </ButtonM>
          <ButtonM onClick={onConfirm} color="secondary">
            Yes
          </ButtonM>
        </DialogActions>
      </Dialog>
    );
  };

  // console.log("CI ML ==> ",currentItemToRemove)

  const onClickDeleteContent = async({fileName,fileType,parentId,resourceID,fileURL}) => {

    // console.log("fileName ML => ",fileName)
    // console.log("fileType ML => ",fileType)
    // console.log("parentId ML => ",parentId)
    // console.log("resource ID ML => ",resourceID)
    // console.log("currentUser ML => ",auth.currentUser.uid)
    // console.log("fileURL ML => ",fileURL)

    setOpenDialog(false);
    setCurrentItemToRemove(null);

    try {
      let response = await axios.delete(
        `${API_BASE_URL}${ADMIN_DELETE_ASYNCHRONOUS_CONTENT}`,
        {
          data: {
              user_id: auth.currentUser.uid, 
              resource_id: resourceID, 
              parent_id: parentId, 
              type: fileType, 
              file_name: fileName,
              file_url:fileURL
          }
      }
      );
      handleRefresh();
      handleCloseResource();
      console.log("Response deleting resourse ML : ",response)

      toast.success("Media Deleted.", {
        position: toast.POSITION.TOP_CENTER,
        hideProgressBar: true,
        autoClose: 3000,
      });

    } catch (error) {

      console.log("Error while deleting resource: ", error);

      if (error.response && error.response.data) {

          console.log("Detailed error message: ", error.response.data.message);

          toast.error(error.response.data.message, {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: true,
              autoClose: 3000,
          });

      } else {
          
          toast.error(error, {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: true,
              autoClose: 3000,
          });
      }
      }



  }

  const handleRefresh = () => {
    // Fetch: Resource list
    handleFetchResourceList(setFetchingResourceList, setResourceList, filter);
  };

  useEffect(() => {
    // Fetch: Resource list
    handleFetchResourceList(setFetchingResourceList, setResourceList, filter);
  }, [filter]);

  return (
    <React.Fragment>
      <div className="p-3" style={{ height: "100vh", overflowY: "auto" }}>

        <div className="row">
          <div className="col-md-12 mb-3">
            <h4 className="text-white">Files &amp; Videos</h4>
          </div>
        </div>
        <div className="row">
          <div className={showResourceDetails ? "col-md-8" : "col-md-12"}>
            <div className="text-white border border-secondary">
              <div className="d-flex align-items-end justify-content-between px-3 py-2">
                <div className="d-flex flex-column justify-content-start">
                  <Dropdown className="w-100">
                    <Dropdown.Toggle
                      variant="light"
                      id="dropdown-basic"
                      size="sm"
                    >
                      <span className="text-capitalize">
                        {filter === "" ? (
                          <span>
                            <FontAwesomeIcon
                              icon={faThLarge}
                              className="mr-2"
                            />{" "}
                            View all
                          </span>
                        ) : filter === "lecture" ? (
                          <span>
                            <FontAwesomeIcon icon={faVideo} className="mr-2" />
                            Lectures
                          </span>
                        ) : (
                          <span>
                            <FontAwesomeIcon icon={faFile} className="mr-2" />
                            Files
                          </span>
                        )}
                      </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => setFilter("")}>
                        <FontAwesomeIcon icon={faThLarge} className="mr-2" />{" "}
                        View all
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setFilter("lecture")}>
                        <FontAwesomeIcon icon={faVideo} className="mr-2" />
                        Lectures
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => setFilter("file")}>
                        <FontAwesomeIcon icon={faFile} className="mr-2" />
                        Files
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="d-flex align-items-end">
                  {fetchingResourceList && (
                    <div className="mr-3">
                      <p className="mb-0">Fetching...</p>
                    </div>
                  )}
                  <Button
                    variant="light"
                    size="sm"
                    onClick={handleRefresh}
                    disabled={fetchingResourceList}
                    className="mr-3"
                  >
                    {fetchingResourceList ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      <FontAwesomeIcon icon={faRedo} />
                    )}{" "}
                    Refresh
                  </Button>
                  <div className="d-flex flex-column justify-content-end">
                    <Dropdown className="pointer no-dropdown-caret ml-auto">
                      <Dropdown.Toggle
                        as="div"
                        id="dropdown-basic"
                        className="btn btn-primary btn-sm text-uppercase"
                      >
                        <FontAwesomeIcon icon={faUpload} className="mr-2" />
                        Add New
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          className=""
                          onClick={() => {
                            setNewResourceDetails((prev) => {
                              return {
                                ...prev,
                                type: "lecture",
                              };
                            });
                            setShowAddResourceModal(true);
                          }}
                        >
                          <div className="d-flex">
                            <img
                              src="data:image/png;base64,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"
                              width="30px"
                              height="30px"
                              className="mr-2"
                            />
                            <div>
                              <span className="font-weight-bold text-uppercase  small">
                                Add Recorded Lecture
                              </span>
                              <p className="small my-0 ">
                                Select a video file (MP4 only)
                              </p>
                            </div>
                          </div>
                        </Dropdown.Item>
                        <Dropdown.Item
                          className=""
                          onClick={() => {
                            setNewResourceDetails((prev) => {
                              return {
                                ...prev,
                                type: "file",
                              };
                            });
                            setShowAddResourceModal(true);
                          }}
                        >
                          <div className="d-flex">
                            <img
                              src="data:image/png;base64,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"
                              width="30px"
                              height="30px"
                              className="mr-2"
                            />
                            <div>
                              <span className="font-weight-bold text-uppercase  small">
                                Add File
                              </span>
                              <p className="small my-0 ">
                                Select a document (all image and document extentions allowed)
                              </p>
                            </div>
                          </div>
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <table class="table table-borderless text-white">
                <thead className="border-top border-secondary">
                  <tr className="">
                    <th className="py-1 font-weight-bold small">#</th>
                    <th className="py-1 font-weight-bold small">Name</th>
                    <th className="py-1 font-weight-bold small">Format</th>
                    <th className="py-1 font-weight-bold small">Size</th>
                    {filter === "" && (
                      <th className="py-1 font-weight-bold small">Category</th>
                    )}
                    <th className="py-1 font-weight-bold small">Created</th>
                  </tr>
                </thead>
                <tbody>
                  {resourceList?.map((item, key) => (
                    <tr
                      className="border-top border-secondary align-items-center pointer"
                      key={key}
                      onClick={() => handleOpenResource(item)}
                      style={
                        selectedResource?.id === item.id
                          ? {
                            fontSize: "90%",
                            backgroundColor: "rgba(200, 200, 200, 0.15)",
                          }
                          : { fontSize: "90%" }
                      }
                    >
                      <td>{key + 1}</td>
                      {item?.type === "file" ? (
                        <td className="d-flex align-items-center">
                          <FileIcon
                            file_content_type={item?.file_content_type}
                          />
                          <span>{item?.file_name}</span>
                        </td>
                      ) : (
                        <td className="d-flex align-items-center">
                          <FontAwesomeIcon icon={faVideo} className="mr-2" />
                          <span>{item?.file_name}</span>
                        </td>
                      )}
                      <td>{item?.file_content_type}</td>
                      <td>{fileSize(item?.file_size)}</td>
                      {filter === "" && (
                        <td className="text-uppercase">{item?.type}</td>
                      )}
                      <td>{moment(item?.timestamp).format("MMM DD, YYYY")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {showResourceDetails && (
            <div className="col-md-4 p-0 m-0 h-100">
              <div className="border border-secondary text-white mr-3">
                <div className="p-3 d-flex align-items-center border-bottom border-secondary">
                  <h5 className="flex-grow-1 mb-0">
                    {selectedResource?.type === "file" ? (
                      <FileIcon
                        file_content_type={selectedResource?.file_content_type}
                      />
                    ) : (
                      <FontAwesomeIcon icon={faVideo} className="mr-2" />
                    )}
                    {selectedResource?.file_name}
                  </h5>
                  <a
                    className="text-white pointer p-2"
                    onClick={handleCloseResource}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </a>
                </div>
                <div className="p-3">
                  {/* Preview: File type */}
                  {selectedResource?.type === "file" &&
                    (image_type?.includes(
                      selectedResource?.file_content_type
                    ) ? (
                      <div className="d-flex justify-content-center">
                        {/* Preview: Image files */}
                        <figure>
                          <Zoom>
                            <img
                              alt={selectedResource?.file_name}
                              src={selectedResource?.file_url}
                              className="img-fluid w-100"
                            />
                          </Zoom>
                        </figure>
                      </div>
                    ) : (
                      <div>
                        {/* Preview: Other files */}
                        <a
                          href={selectedResource?.file_url}
                          className="d-flex align-items-center border rounded-sm p-1"
                          target="_blank"
                        >
                          <FileIcon
                            size="2x"
                            file_content_type={
                              selectedResource?.file_content_type
                            }
                          />
                          <span>{selectedResource?.file_name}</span>
                        </a>
                      </div>
                    ))}

                  {/* Preview: Lecture type */}
                  {selectedResource?.type === "lecture" && (
                    <div className="w-100">
                      <div className="embed-responsive embed-responsive-16by9">
                        <ReactPlayer
                          controls
                          stopOnUnmount
                          width="100%"
                          height="auto"
                          playing={false}
                          muted
                          config={{
                            file: {
                              attributes: {
                                disablePictureInPicture: true,
                                noDownload: true,
                                controlsList: "nodownload noremoteplayback",
                              },
                            },
                          }}
                          url={selectedResource?.file_url}
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                  )}

                  <div className="my-3">
                    <p className="text-muted small mb-0">Name</p>
                    <p className="small mb-0">
                      <a href={selectedResource?.file_url} target="_blank">
                        {selectedResource?.file_name}
                      </a>
                    </p>
                  </div>
                  <div className="mb-3">
                    <p className="text-muted small mb-0">Size</p>
                    <p className="small mb-0">
                      {fileSize(selectedResource?.file_size)}
                    </p>
                  </div>
                  <div className="mb-3">
                    <p className="text-muted small mb-0">Type</p>
                    <p className="small mb-0">
                      {selectedResource?.file_content_type}
                    </p>
                  </div>
                  <div className="mb-3">
                    <p className="text-muted small mb-0">Category</p>
                    <p className="small mb-0 text-uppercase">
                      {selectedResource?.type}
                    </p>
                  </div>
                  <div className="mb-3">
                    <p className="text-muted small mb-0">Created at</p>
                    <p className="small mb-0">
                      {moment(selectedResource?.timestamp).format("LLLL")}
                    </p>
                  </div>

                  <div className="mb-3">
                    <>
                    <Button
                      onClick={() => {
                        setOpenDialog(true);
                        setCurrentItemToRemove(
                          {
                            fileName:selectedResource?.file_name,
                            fileType:selectedResource?.file_content_type,
                            parentId:selectedResource?.parent_id,
                            resourceID:selectedResource?.id,
                            fileURL: selectedResource?.file_url
                          }
                        )
                      }}
                      size="sm"
                      className="btn-sm btn-danger"
                      style={{cursor:"pointer"}}
                    >
                      <FontAwesomeIcon size="sm" icon={faTrash} /> Remove
                    </Button>
                    <ConfirmationDialog
                      open={openDialog}
                      onClose={handleCloseDialog}
                      onConfirm={() => onClickDeleteContent(currentItemToRemove)}
                    />
                    </>
                  </div>

                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Modal: Add Async Content */}
      <Modal onHide={handleCloseAsyncContentModal} show={showAddResourceModal}>
        <Modal.Header closeButton>
          <div>
            <p className="lead mb-1">
              Upload a{" "}
              {newResourceDetails?.type === "lecture"
                ? "Recorded Lecture"
                : "Resource"}
            </p>
          </div>
        </Modal.Header>
        <Modal.Body>
          {status === "success" && response?.resource_type === "lecture" && (
            <div>
              <div className="embed-responsive embed-responsive-16by9">
                <ReactPlayer
                  controls
                  stopOnUnmount
                  width="100%"
                  height="auto"
                  playing
                  config={{
                    file: {
                      attributes: {
                        disablePictureInPicture: true,
                        noDownload: true,
                        controlsList: "nodownload noremoteplayback",
                      },
                    },
                  }}
                  url={response?.resource_file_url}
                />
              </div>
              <p className="lead">{response?.resource_title}</p>
            </div>
          )}

          {status === "success" && response?.resource_type === "file" && (
            <a
              className="border rounded d-flex p-1 mb-3"
              href={response?.resource_file_url}
              target="_blank"
            >
              <div className="mr-2">
                <FontAwesomeIcon icon={faFile} size="3x" />
              </div>
              <div className="flex-grow-1">
                <p className="mb-0">{response?.resource_title}</p>
              </div>
            </a>
          )}

          {status != "success" && (
            <Form onSubmit={handleRecordedLectureForm}>
              <Form.Group>
                <Form.Label className="text-uppercase small text-muted">
                  <b>
                    {newResourceDetails?.type === "lecture"
                      ? "Recorded Lecture"
                      : "Resource"}{" "}
                    File
                  </b>
                </Form.Label>
                <Form.Control
                  name="resource_file"
                  id="resource_file"
                  type="file"
                  accept={
                    newResourceDetails?.type === "lecture" ? "video/*" : ""
                  }
                  onChange={(e) => {
                    setResourceFile(e.target.files[0]);
                    setResourceTitle((prev) => {
                      return prev === "" ? e.target.files[0]?.name : prev;
                    });
                  }}
                  disabled={uploading}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label className="text-uppercase small text-muted">
                  <b>
                    {newResourceDetails?.type === "lecture"
                      ? "Recorded Lecture"
                      : "Resource"}{" "}
                    Title
                  </b>
                </Form.Label>
                <Form.Control
                  name="resource_title"
                  id="resource_title"
                  placeholder="Enter Resource title"
                  onChange={(e) => setResourceTitle(e.target.value)}
                  value={resourceTitle}
                  type="text"
                  disabled={uploading}
                />
              </Form.Group>

              {status === "start" && (
                <Button
                  className="w-100"
                  type="submit"
                  disabled={uploading || progress === 100}
                >
                  {progress === 100
                    ? "Almost done"
                    : uploading
                      ? `Uploading ${progress}%`
                      : "Upload"}
                </Button>
              )}

              {status === "await" && (
                <div className="w-100 border rounded d-flex align-items-center justify-content-center">
                  <div className="d-flex p-1 align-items-center justify-content-center text-muted">
                    <Spinner
                      size="sm"
                      animation="border"
                      className="m-0 p-0 mr-2"
                    />
                    <p className="mb-0">Processing</p>
                  </div>
                </div>
              )}
            </Form>
          )}

          {status === "success" && (
            <>
              <div className="w-100 border rounded d-flex align-items-center justify-content-center mb-2">
                <div className="d-flex p-1 align-items-center justify-content-center text-success">
                  <FontAwesomeIcon icon={faCheck} className="m-0 p-0 mr-2" />
                  <p className="mb-0">Success</p>
                </div>
              </div>
              <Button onClick={handleCloseAsyncContentModal} size="sm">
                <div className="d-flex p-1 align-items-center justify-content-center text-uppercase">
                  <FontAwesomeIcon icon={faCheck} className="m-0 p-0 mr-2" />
                  <p className="mb-0">Close</p>
                </div>
              </Button>
            </>
          )}

          {status === "failure" && (
            <>
              <div className="w-100 border rounded d-flex align-items-center justify-content-center mb-2">
                <div className="d-flex p-1 align-items-center justify-content-center text-danger">
                  <FontAwesomeIcon icon={faTimes} className="m-0 p-0 mr-2" />
                  <p className="mb-0">Failed</p>
                </div>
              </div>
              <p className="small text-danger">
                <b>Error: </b>
                {errorMsg}
              </p>
              <Button
                onClick={handleCloseAsyncContentModal}
                variant="secondary"
                size="sm"
              >
                <div className="d-flex p-1 align-items-center justify-content-center text-uppercase">
                  <FontAwesomeIcon icon={faTimes} className="m-0 p-0 mr-2" />
                  <p className="mb-0">Close</p>
                </div>
              </Button>
            </>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  currentEvent: state.currentEvent,
});

export default connect(mapStateToProps)(Resources);
